define('controllers/news',[
    'underscore',
    'controllers/base/controller',
    'views/pages/news/index',
    'models/pages/news/news',
    'models/pages/news/news-view',
    'views/pages/news/view'
], function(
    _,
    Controller,
    NewsPageView,
    NewsPageModel,
    NewsViewModel,
    NewsView
) {
    'use strict';

    var NewsController = Controller.extend({

        list: function(params) {

            var model = new NewsPageModel({ tag: decodeURIComponent(params.tag) });

            this.view = new NewsPageView({
                model: model
            });

            model.load();
        },

        item: function(params) {

            var fromDate, toDate;

            fromDate = new Date(params.fromDate);
            toDate = new Date(params.toDate);

            if (!fromDate.valueOf() || !toDate.valueOf()) {
                var nowTemp = new Date();
                toDate = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);
                fromDate = new Date();
                fromDate.setTime(toDate.getTime() - 1000 * 60 * 60 * 24 * 30 );
            }

            var model = new NewsViewModel({
                ID: params.newsId,
                fromDate: fromDate,
                toDate: toDate
            });

            this.view = new NewsView({
                model: model
            });

            model.load();
        }

    });

    return NewsController;
});

